/**
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 接口地址https://manbingapi.huayiyun.net   https://demo.huayiyun.net:8084   http://localhost:8080  https://demo.huayiyun.net:8082/ncd
 * rootUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 */

// let baseUrl = 'https://manbingapi.huayiyun.net'
// let baseUrl = 'http://192.168.2.155:9999/manbing/'
let baseUrl = 'https://demo.huayiyun.net:8082/ncd'
let routerMode = 'hash';
var imgBaseUrl ='';
// let rootUrl = 'https://manbing.huayiyun.net'
let rootUrl = 'https://demo.huayiyun.net:8082/ncd'
let appKey = '027c85232797c251aef236e68191730f'
if (process.env.NODE_ENV === 'development') {
    imgBaseUrl = 'http://t-chronicdisease.oss-cn-beijing.aliyuncs.com/';
} else if (process.env.NODE_ENV === 'production') {
    // baseUrl = 'https://manbingapi.huayiyun.net';
    baseUrl = 'https://demo.huayiyun.net:8082/ncd';
    imgBaseUrl = 'http://t-chronicdisease.oss-cn-beijing.aliyuncs.com/';
}

let getImgCode=baseUrl+'/system/getImgVerifyCode';
export {
    baseUrl,
    rootUrl,
    routerMode,
    imgBaseUrl,
    appKey,
    getImgCode
}



// WEBPACK FOOTER //
// ./src/config/env.js